import { useMemo } from "react";

import { CheckAuthHocV2 } from "@stadium/services/auth0";

import { LOGIN_CALLBACK_ROUTE } from "@constants/routes";
import { ORDER_SERVICE_API_BASE_URL } from "@constants/env-variables";
import Loaders from "@stadium/ui/src/components/loaders/loaders";
import { usePreviewModeContext } from "@contexts/preview-mode-context";

const CheckAuthWithPreviewMode = (WrappedComponent) => {
  function WrappingComponent(props) {
    const { previewMode } = usePreviewModeContext();

    const WrappedComponentWithAuth = useMemo(
      () =>
        CheckAuthHocV2(WrappedComponent, {
          apiHost: ORDER_SERVICE_API_BASE_URL,
          Loader: Loaders.PageLoader,
          loginCallbackRoute: LOGIN_CALLBACK_ROUTE,
        }),
      [WrappedComponent],
    );

    if (previewMode) return <WrappedComponent {...props} />;

    return <WrappedComponentWithAuth {...props} />;
  }
  return WrappingComponent;
};

export default CheckAuthWithPreviewMode;
